import React, { useEffect, useState } from 'react';
import { IconMaterial } from '../shared/iconMaterial/IconMaterial';
import { useTranslation } from 'react-i18next';
import SelectInput from '../shared/ui/input/SelectInput';
import DateRangeInput from '../shared/ui/input/DateRangeInput';
import { useOrders } from '../../context/OrdersProvider';

export interface FilterOrderPanelProps {
    isOpen: boolean;
    onClose: () => void;
    className?: string;
}

const FilterOrderPanel: React.FC<FilterOrderPanelProps> = ({
    isOpen,
    onClose,
    className = ''
}) => {
    const {
        fromDate,
        toDate,
        setFromDate,
        setToDate,
        getDeviceSelector,
        selectedDevice,
        setSelectedDevice,
    } = useOrders()
    const [devices, setDevices] = useState([] as any);

    const { t } = useTranslation()
    const i18nOrderDirectory = (key: string): string =>
        t(`orders-directory.${key}`)

    const fetchDevices = async () => {
        const result = await getDeviceSelector()
        setDevices(result.results)
    }

    useEffect(() => {
        if (isOpen) {
            fetchDevices()
        }
    }, [isOpen])

    return (
        <>
            <div
                className={`p-4 top-0 right-0 h-full w-[450px] bg-white border-l transform transition-transform duration-300 ease-in-out z-40 ${isOpen ? 'translate-x-0' : 'translate-x-full'
                    } ${className}`}
            >
                <div className="flex items-center justify-between ">
                    <div className="flex items-center gap-3">
                        <div>
                            <h2
                                className="text-lg font-semibold text-gray-900 font-montserrat  truncate max-w-[250px]"
                                title={i18nOrderDirectory('filters')}
                            >
                                {i18nOrderDirectory('filters')}
                            </h2>
                            <p className="text-sm text-gray-600 font-montserrat">
                            </p>
                        </div>
                    </div>

                    <div className="flex items-center gap-2">

                        <div
                            className="p-2 text-gray-400 flex items-center justify-center border cursor-pointer hover:text-gray-600 transition-colors rounded-lg hover:bg-gray-100"
                            onClick={() => onClose()}
                        >
                            <IconMaterial
                                filled
                                icon="close"
                                className="cursor-pointer"
                                size={20}
                            />
                        </div>
                    </div>
                </div>
                <div className='flex flex-col gap-4 py-6 text-sm text-primary-dark text-bold font-medium'>
                    <p>{i18nOrderDirectory('by-target-device')}</p>
                    <SelectInput
                        name="device_model"
                        required
                        placeholder='Select device'
                        clearable
                        onClear={() => setSelectedDevice(null)}
                        value={selectedDevice}
                        onChange={(value) => setSelectedDevice(value)}
                        options={devices?.map((device: any) => ({
                            id: device.id,
                            label: device.name,
                        }))}
                    />
                    <p>{i18nOrderDirectory('by-date')}</p>
                    <DateRangeInput
                        fromDate={fromDate}
                        toDate={toDate}
                        onFromDateChange={setFromDate}
                        onToDateChange={setToDate}
                        fromLabel={i18nOrderDirectory('from-date')}
                        toLabel={i18nOrderDirectory('to-date')}
                        fromPlaceholder={i18nOrderDirectory('select-from-date')}
                        toPlaceholder={i18nOrderDirectory('select-to-date')}
                    />
                </div>
            </div>
        </>
    );
};

export default FilterOrderPanel;